/**
 *
 * Asynchronously loads the component for AccessControlRolePermissions
 *
 */
import Loadable from 'react-loadable';
export default Loadable({
    loader: function () {
        return import(/* webpackChunkName: 'AccessControlRolePermissions' */ './index');
    },
    loading: function (props) {
        if (props.error) {
            console.error(props.error);
        }
        return null;
    },
});
